import { render, staticRenderFns } from "./cv-checkbox-skeleton.vue?vue&type=template&id=6894e88a&"
import script from "./cv-checkbox-skeleton.vue?vue&type=script&lang=js&"
export * from "./cv-checkbox-skeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports